/**
 * Error extension to indicate AJAX related errors.
 * @class
 * @extends Error
 */
export default class AjaxError extends Error {
    /**
     * @param {string} message
     * @param {Response} response
     */
    constructor(message, response) {
        super(message);
        this.name = 'AjaxError';
        this.response = response;
    }

    /**
     * Returns the status code from the Response instance.
     * @returns {string} The response status code.
     */
    get status() {
        return this.response.status;
    }

    /**
     * Returns the response message from the Response instance.
     * @returns {string} The response status message.
     */
    get statusMessage() {
        return this.response.statusMessage;
    }
}

export { AjaxError };